import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BundledResponses, DaisyChainVideoPrompts, VideoFormat, VideoOrAudioOnlyResponse } from '../data/daisychain';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DataService } from '../data/data.service';
import { Options, Source } from '../data/video-js-options';
import { Student } from '../data/student';
import promptsJson from '../../assets/DaisyChainVideoPrompts.json';

@Component({
    selector: 'app-daisychain-response',
    templateUrl: './daisychain-response.component.html',
    styleUrls: ['./daisychain-response.component.css']
})
export class DaisychainResponseComponent implements OnInit {
    @Input() data: BundledResponses;
    @Input() studentID: number;
    @Output() onVideoLoadStarted = new EventEmitter<string>();
    studentThumbnailUrl: SafeResourceUrl;
    urlString: string;
    actorThumbnailUrl: string;
    isLoadingStudentThumbnail: boolean;
    studentVideoURL: SafeResourceUrl;
    selectedVideoURL: any;
    showStudentVideoPlayer: boolean;
    loadingStudentVideo: boolean;
    showActorVideoPlayer: boolean;
    selectedVideoHtmlType: string;
    studentVideoHtmlType: string;
    optionsForStudentVideo: Options;
    optionsForActorVideo: Options;
    prompts = (promptsJson as DaisyChainVideoPrompts);
    promptText: string;

    constructor(
        protected sanitizer: DomSanitizer,
        protected dataService: DataService
    ) { }

    ngOnInit() {
        this.isLoadingStudentThumbnail = true;
        var videoName = this.data.BotResponses[this.data.BotResponses.length - 1].VideoID;
        var videoPrompt = this.prompts.VideoPrompts.find(x => x.VideoFilename == videoName);
        this.promptText = videoPrompt ? videoPrompt.Prompt : "No Prompt For This Video";
        var botName = this.data.BotResponses[this.data.BotResponses.length - 1].CreatorID;
        this.actorThumbnailUrl = "https://d176fjak4re5qk.cloudfront.net/Videos/HLS/" + botName + "/" + videoName + "/" + videoName + ".jpeg";
        this.loadActorVideoPlayer();
        if (this.data.StudentResponse.VideoFormat == VideoFormat.mp4) this.studentVideoHtmlType = 'video/mp4';
        else if (this.data.StudentResponse.VideoFormat == VideoFormat.webm) this.studentVideoHtmlType = 'video/webm';
        else if (this.data.StudentResponse.VideoFormat == VideoFormat.audioOnly) this.studentVideoHtmlType = 'audio/mp3';
        else console.error("unknown video format\n:" + this.data.StudentResponse);

        if (this.data.StudentResponse.VideoFormat != VideoFormat.audioOnly)
        {
            this.dataService.getArtifactString(this.studentID, this.data.StudentResponse.ThumbnailArtifactID).subscribe(x => {
                if (this.studentThumbnailUrl != null) this.studentThumbnailUrl = this.getArtifactImageBytes(x);
                this.isLoadingStudentThumbnail = false;
            });
        } 
        if (this.data.StudentResponse.VideoID.includes("blob:https://devplay.joyschoolenglish.com/") ||
            !this.studentVideoHtmlType)
            return;

        this.dataService.getArtifactString(this.studentID, this.data.StudentResponse.VideoID).subscribe(x => {
            this.studentVideoURL = this.getArtifactVideoBytes(x);
            this.loadStudentVideoPlayer();
        });
    }


    loadStudentVideoPlayer() {

        this.selectedVideoHtmlType = this.studentVideoHtmlType;
        this.selectedVideoURL = this.studentVideoURL;
        this.optionsForStudentVideo = new Options();
        this.optionsForStudentVideo.height = "150%";
        this.optionsForStudentVideo.width = "auto";
        this.optionsForStudentVideo.sources = new Array();
        this.optionsForStudentVideo.muted = false;
        this.optionsForStudentVideo.audioPosterMode = false;
        if(this.studentVideoHtmlType == "audio/mp3")
        {
            this.optionsForStudentVideo.poster = "assets/voiceonly_thumbnail.png"
            this.optionsForStudentVideo.audioPosterMode = true;
        }   
        var source = new Source();
        source.src = this.urlString;
        source.type = this.selectedVideoHtmlType;
        this.optionsForStudentVideo.sources.push(source);
        this.showStudentVideoPlayer = true;
    }

    loadActorVideoPlayer() {
        var videoName = this.data.BotResponses[this.data.BotResponses.length - 1].VideoID;
        var botName = this.data.BotResponses[this.data.BotResponses.length - 1].CreatorID;
        this.selectedVideoURL = "https://d176fjak4re5qk.cloudfront.net/Videos/HLS/" + botName + "/" + videoName + "/" + videoName + ".m3u8";
        console.log(this.selectedVideoURL);
        this.selectedVideoHtmlType = 'application/x-mpegURL';
        this.optionsForActorVideo = new Options();
        this.optionsForActorVideo.height = 'auto';
        this.optionsForActorVideo.width = '100%';
        this.optionsForActorVideo.preload = "auto";
        this.optionsForActorVideo.muted = false;
        this.optionsForActorVideo.audioPosterMode = false;
        this.optionsForActorVideo.sources = new Array();
        var source = new Source();
        source.src = this.selectedVideoURL;
        source.type = this.selectedVideoHtmlType;
        this.optionsForActorVideo.sources.push(source);
        this.showActorVideoPlayer = true;
    }

    getArtifactImageBytes(artifactString: string): SafeResourceUrl {
        if (artifactString) {
            if (artifactString) {
                var unsafeURL = URL.createObjectURL(new Blob([this.convertEncodedDataToBinary(artifactString)], { type: 'image/png' }));
            }
            return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeURL);
        }
    }

    getArtifactVideoBytes(artifactString: string): SafeResourceUrl {
        if (artifactString) {
            var unsafeURL = URL.createObjectURL(new Blob([this.convertEncodedDataToBinary(artifactString)], { type: this.studentVideoHtmlType }));
            this.urlString = unsafeURL;
            return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeURL);
        }
        else {
            return null;
        }
    }

    convertEncodedDataToBinary(base64): Uint8Array {
        if (base64) {
            var raw = window.atob(base64);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));
            for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
            }
        }
        return array;
    }
    changeShowStudentVideoPlayer(val: boolean) {
        this.showStudentVideoPlayer = val;
    }
    changeShowActorVideoPlayer(val: boolean) {
        this.showActorVideoPlayer = val;
    }
    playWasCalled(id: string) {
        this.onVideoLoadStarted.emit(id);
    }


}

